import { api } from "@/api/api";
import { paramsReducer } from "@/api/utils";
import type {
  ApiResponse,
  ModuleRead,
  ModuleReadList,
  ModuleWrite,
  OverviewModuleRead,
} from "@/types/api/types";
import type { ModuleStatus } from "@/types/api/enums";

export const ModulesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getModules: builder.query<ApiResponse<ModuleRead>, any>({
      query: (params) => paramsReducer("modules", params),
      providesTags: ["Modules"],
    }),
    getOptimizedModules: builder.query<ApiResponse<ModuleReadList>, any>({
      query: (params) => paramsReducer("optimized_modules", params),
      providesTags: ["Modules"],
    }),
    getModulesOverview: builder.query<ApiResponse<OverviewModuleRead>, any>({
      query: (params) => paramsReducer("modules/overview", params),
      providesTags: ["Modules"],
    }),
    getModule: builder.query<ModuleRead, string>({
      query: (uuid: string) => `modules/${uuid}`,
      providesTags: ["Modules"],
    }),
    getModuleNextStatuses: builder.query<
      ApiResponse<ModuleStatus>,
      { uuid: string }
    >({
      query: ({ uuid }) => `modules/${uuid}/next_statuses`,
      providesTags: ["Modules"],
    }),
    updateModule: builder.mutation({
      query({ uuid, body }: { uuid: string; body: ModuleWrite }) {
        return {
          url: `modules/${uuid}`,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: ["Modules"],
    }),
    addModule: builder.mutation({
      query(body: ModuleWrite) {
        return {
          url: `modules`,
          method: "POST",
          body,
        };
      },
      invalidatesTags: ["Modules"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetModulesOverviewQuery,
  useGetModulesQuery,
  useGetOptimizedModulesQuery,
  useGetModuleQuery,
  useGetModuleNextStatusesQuery,
  useUpdateModuleMutation,
  useAddModuleMutation,
} = ModulesApi;
